var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home" }, [
    _c("div", [_c("header-barto")], 1),
    _c("div", { staticClass: "banner-header" }, [
      _c("div", { staticClass: "banner" }, [
        _c("div", { staticClass: "banner-inner" }, [
          _c("p", { staticClass: "title" }, [
            _vm._v(" " + _vm._s(_vm.$t("homes.intoCapital")) + " "),
          ]),
          _c("div", { staticClass: "search-bar" }, [
            _c(
              "div",
              { staticClass: "selects" },
              _vm._l(_vm.searchTypeOptions, function (item) {
                return _c(
                  "div",
                  {
                    key: item.value,
                    staticClass: "select-btn",
                    class: _vm.params.searchType === item.value ? "active" : "",
                    on: {
                      click: function ($event) {
                        return _vm.changeSearchType(item.value)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item.label))]
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "search" },
              [
                _c(
                  "auto-complete",
                  {
                    ref: "searchInput",
                    staticClass: "search-input",
                    class: _vm.params.searchType === 2 ? "with-select" : "",
                    attrs: {
                      "popper-class": "search-input-popper",
                      size: "medium",
                      "trigger-on-focus": false,
                      "select-when-unmatched": true,
                      placeholder:
                        _vm.$t("homes.enter") +
                        `${
                          _vm.params.searchType === 1
                            ? _vm.$t("keyWord")
                            : _vm.params.searchType === 2
                            ? _vm.$t("hsCode")
                            : _vm.$t("companyName")
                        }` +
                        _vm.$t("homes.search"),
                    },
                    model: {
                      value: _vm.params.keyword,
                      callback: function ($$v) {
                        _vm.$set(_vm.params, "keyword", $$v)
                      },
                      expression: "params.keyword",
                    },
                  },
                  [
                    _vm.params.searchType === 2
                      ? _c(
                          "el-select",
                          {
                            attrs: {
                              slot: "prepend",
                              placeholder: _vm.$t("dashboardCont.pleaseSelect"),
                            },
                            slot: "prepend",
                            model: {
                              value: _vm.params.countryId,
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "countryId", $$v)
                              },
                              expression: "params.countryId",
                            },
                          },
                          _vm._l(_vm.countryOptions, function (op) {
                            return _c("el-option", {
                              key: op.value,
                              attrs: { label: op.label, value: op.value },
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                    _c("svg-icon", {
                      attrs: { slot: "prefix", name: "search" },
                      slot: "prefix",
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "datas" }, [
        _c(
          "div",
          { staticClass: "datas-top" },
          _vm._l(_vm.showDatas, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "name",
                class: { active: _vm.activeData === index },
                attrs: { id: "data-name" },
                on: {
                  mouseenter: (e) => _vm.changeActiveData(e, index),
                  mouseleave: (e) => _vm.changeActiveData(e, index),
                },
              },
              [
                _c("svg-icon", { attrs: { name: item.icon, id: "data-name" } }),
                _c("span", { attrs: { id: "data-name" } }, [
                  _vm._v(_vm._s(item.title)),
                ]),
              ],
              1
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "data-inner", attrs: { id: "data-inner" } },
          [
            _vm.activeData > -1
              ? [
                  _vm.activeData % 2 === 1
                    ? _c("img", {
                        staticClass: "left-img",
                        attrs: {
                          src: _vm.activeDataObj.img,
                          alt: "",
                          id: "data-inner",
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "intro", attrs: { id: "data-inner" } },
                    [
                      _c(
                        "p",
                        { staticClass: "title", attrs: { id: "data-inner" } },
                        [_vm._v(_vm._s(_vm.activeDataObj.title))]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "sub-title",
                          attrs: { id: "data-inner" },
                        },
                        [_vm._v(_vm._s(_vm.activeDataObj.en))]
                      ),
                      _c("p", {
                        staticClass: "text",
                        attrs: { id: "data-inner" },
                        domProps: { innerHTML: _vm._s(_vm.activeDataObj.text) },
                      }),
                    ]
                  ),
                  _vm.activeData % 2 === 0
                    ? _c("img", {
                        staticClass: "right-img",
                        attrs: {
                          src: _vm.activeDataObj.img,
                          alt: "",
                          id: "data-inner",
                        },
                      })
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }